import { render, staticRenderFns } from "./sbToolbar.vue?vue&type=template&id=631a2152&scoped=true"
import script from "./sbToolbar.vue?vue&type=script&lang=ts"
export * from "./sbToolbar.vue?vue&type=script&lang=ts"
import style0 from "./sbToolbar.vue?vue&type=style&index=0&id=631a2152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631a2152",
  null
  
)

export default component.exports